export class Inventory {
  constructor(
    _id,
    locations,
    Illu,
    width,
    height,
    CodeNo,
    CASCode,
    typeOfMedia,
    img,
    vendor,
    ratePerMonth,
    maintenanceRate,
    Bookings,
    lat,
    lng,
    startDate,
    endDate,
    blocked,
    blockedFor,
    blockedAt,
    blockedTill,
    unit,
    isTrading,
    Availability,
    focBookings,
    half1Id,
    half2Id,
    fullId,
    blockedDates,
    premiumBlock,
    isArchived,
    removedOn
  ) {
    this._id = _id;
    this.locations = {
      city: locations.city,
      Area: locations.Area,
      name: locations.name,
      zone: locations.zone,
    };
    this.Illu = Illu;
    this.width = width;
    this.height = height;
    this.CodeNo = CodeNo;
    this.CASCode = CASCode;
    this.typeOfMedia = typeOfMedia;
    this.img = img;
    this.vendor = vendor;
    this.ratePerMonth = ratePerMonth;
    this.maintenanceRate = maintenanceRate;
    this.Bookings = Bookings;
    this.lat = lat;
    this.lng = lng;
    this.startDate = startDate;
    this.endDate = endDate;
    this.blocked = blocked;
    this.blockedAt = blockedAt;
    this.blockedFor = blockedFor;
    this.blockedTill = blockedTill;
    this.unit = unit;
    this.isTrading = isTrading;
    this.Availability = Availability;
    this.focBookings = focBookings;
    this.half1Id = half1Id;
    this.half2Id = half2Id;
    this.fullId = fullId;
    this.blockedDates = blockedDates;
    this.premiumBlock = premiumBlock;
    this.isArchived = isArchived;
    this.removedOn = removedOn;
  }
}
